import React from 'react'
import CubeLoader from '../CubeLoader/CubeLoader'

const OverlayLoader = () => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-[#11111199] backdrop-blur-[3px] z-[1000000]">
      <CubeLoader />
    </div>
  )
}

export default OverlayLoader